export const OuterContainer = {
    overflowY: "auto",
    height: "90vh",
    backgroundColor: "white",
};

export const InnerContainer = {
    width: {
        xs: "95%",
        sm: "540px",
        md: "512px",
        lg: "682px",
        xl: "810px",
    },
    margin: { xs: "auto", md: "0" },
};
